<template>
    <div>
        <ul class="nav nav-pills flex-column pt-3 mynavStyle" ref="box" @scroll='MyScorll($event)'>
            <li class="nav-item">
                <router-link to="/home" class="nav-link text-muted" :class="{'mid':linkshow}">
                    <!--<i class="navbar-icon-shouye"></i>-->
                    <i class="fa fa-home mr-2"></i>
                    <span v-show="!linkshow">Home Page</span>
                </router-link>
            </li>
            <li class="nav-item" v-for="(value, key, index) in leftLists" v-if="key == 'Real-time Info' || key=='Belt & Road Weekly' || key=='China OGP'">
                <router-link :to="{name:value.route, params :{id:value.id, year:value.year, type:value.type}} " :class="{'mid':linkshow}" class="nav-link text-muted">
                    <i v-if="key == 'Real-time Info'" class="fa fa-file-text-o mr-2" title="Real-time Info"></i>
                    <i v-if="key == 'Belt & Road Weekly'" class="fa fa-building-o mr-2" title="Belt & Road Weekly"></i>
                    <i v-if="key == 'China OGP'" class="fa fa-fire mr-2" title="China OGP"></i>
                    <!-- <i v-if="key == 'Trade Reports'" class="fa fa-money mr-2" title="Trade Reports"></i>
                    <i v-if="key == 'Bilateral Trade Reports'" class="fa fa-retweet mr-2" title="Bilateral Trade Reports"></i>
                    <i v-if="key == 'FDI Reports'" class="fa fa-bandcamp mr-2" title="FDI Reports"></i>
                    <i v-if="key == 'Consulting Reports'" class="fa fa-newspaper-o mr-2" title="Consulting Reports"></i>
                    <i v-if="key == 'China Factbox'" class="fa fa-cubes mr-2" title="China Factbox"></i>
                    <i v-if="key == 'Videos'" class="fa fa-play-circle mr-2" title="Videos"></i>
                    <i v-if="key == 'Economic Data'" class="fa fa-database mr-2" title="Economic Data"></i>
                    <i v-if="key == 'Company Inquiry'" class="fa fa-search mr-2" title="Company Inquiry"></i>
                    <i v-if="key == 'China Brands'" class="fa fa-window-restore mr-2" title="China Brands"></i>
                    <i v-if="key == 'Consulting Service'" class="fa fa-graduation-cap mr-2" title="Consulting Service"></i>
                    <i v-if="key == 'Project'" class="fa fa-tasks mr-2" title="Project"></i> -->
                    <span v-show="!linkshow">{{key}}</span>
                </router-link>
            </li>
            <li class="nav-item" v-for="(value, key, index) in leftLists" v-if="key == 'Reports'">
                <div class="nav-link text-muted" :class="{'mid':linkshow}">
                    <div class="btn-group" :class="{'dropright':!linkshow}">
                        <i class="fa fa-newspaper-o mr-2" style="line-height: 35px;"></i>
                        <!-- <i :class="'navbar-icon-' + value.route"></i> -->
                        <span data-toggle="dropdown" v-show="!linkshow" style="pointer-events: none;margin:6px 10px 0 0;">{{key}}</span>
                        <!-- <span class="dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></span> -->
                        <div class="dropdown-menu dropdown-one report_dropdown p-0"
                             style="margin-left: 48px;margin-top: -2px;width:180px;">
                            <ul class="list-group">
                                <li v-for="(val, key) in value" v-if="key!='Trade Reports' && key != 'Consulting Reports'"
                                    class="list-group-item" style="line-height: initial;">
                                    <router-link :to="{name:val.route, params :{id:val.id, year:val.year, type:val.type}}"
                                                 class="nav-link d-inline text-muted">
                                        {{key}}
                                    </router-link>
                                </li>
                                <li v-for="(val, key) in value" v-if="key!='China OGP' && key != 'Bilateral Trade Reports' && key != 'FDI Reports' && key != 'FTZ Reports' && key != 'Investment Policies Reports' && key != 'China Factbox' && key != 'ASEAN Reports' && key != 'Economic Facts Reports' && key != 'Special Reports' && key != 'Provincial Situation' && key != 'Country Investment Reports' && key != 'Provincial Situation'"
                                    class="list-group-item" style="line-height: initial;">
                                    <router-link :to="{name:val.route, params :{id:val.id}}"
                                                 class="nav-link d-inline text-muted">
                                        {{key}}
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>

            </li>


            <li class="nav-item" v-for="(value, key, index) in leftLists" v-if="key == 'Videos' || key=='Economic Data' || key=='Company Inquiry' || key=='China Brands' || key=='Consulting Service' || key=='Project' || key=='China FTZs'">
                <router-link :to="{name:value.route, params :{id:value.id, year:value.year, type:value.type}} " :class="{'mid':linkshow}" class="nav-link text-muted">
                    <i v-if="key == 'Videos'" class="fa fa-play-circle mr-2" title="Videos"></i>
                    <i v-if="key == 'Economic Data'" class="fa fa-database mr-2" title="Economic Data"></i>
                    <i v-if="key == 'Company Inquiry'" class="fa fa-search mr-2" title="Company Inquiry"></i>
                    <i v-if="key == 'China Brands'" class="fa fa-window-restore mr-2" title="China Brands"></i>
                    <i v-if="key == 'Consulting Service'" class="fa fa-graduation-cap mr-2" title="Consulting Service"></i>
                    <i v-if="key == 'Project'" class="fa fa-tasks mr-2" title="Project"></i>
                    <i v-if="key == 'China FTZs'" class="fa fa-window-restore mr-2" title="China FTZs"></i>
                    <span v-show="!linkshow">{{key}}</span>
                </router-link>
            </li>   
<!--            <li class="nav-item">-->
<!--                <router-link to="/home" class="nav-link text-muted" :class="{'mid':linkshow}">-->
<!--                    &lt;!&ndash;<i class="navbar-icon-shouye"></i>&ndash;&gt;-->
<!--                    <i class="fa fa-home mr-2"></i>-->
<!--                    <span v-show="!linkshow">首页</span>-->
<!--                </router-link>-->
<!--            </li>-->
<!--            <li class="nav-item" v-for="(value, key, index) in leftLists" v-if="key == '智讯'">-->
<!--                &lt;!&ndash;<router-link :to="{name:value.route, params :{id:value.id}}" class="nav-link text-muted">&ndash;&gt;-->
<!--                <div class="nav-link text-muted" :class="{'mid':linkshow}">-->
<!--                    <div class="btn-group" :class="{'dropright':!linkshow}">-->
<!--                        <i class="fa fa-at mr-2" style="line-height: 45px;"></i>-->
<!--                        &lt;!&ndash;<i :class="'navbar-icon-' + value.route"></i>&ndash;&gt;-->
<!--                        　-->
<!--                        <a href="javascript:;" v-show="!linkshow" style="pointer-events: none;margin-right: 10px" data-toggle="dropdown">{{key}}</a>-->
<!--                        &lt;!&ndash;<span class="dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->

<!--                          </span>&ndash;&gt;-->
<!--                        <div class="dropdown-menu dropdown-one report_dropdown p-0"-->
<!--                             style="margin-left: 8px;margin-top: -2px;">-->
<!--                            <ul class="list-group">-->
<!--                                <li v-for="(value, key) in value" class="list-group-item w-100"-->
<!--                                    style="line-height: initial;">-->
<!--                                    <router-link :to="{name:value.route, params :{id:value.id}}"-->
<!--                                                 class="nav-link d-inline text-muted">-->
<!--                                        {{key}}-->
<!--                                    </router-link>-->
<!--                                </li>-->
<!--                            </ul>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                </div>-->
<!--                &lt;!&ndash;</router-link>&ndash;&gt;-->
<!--            </li>-->
<!--            <li class="nav-item" v-for="(value, key, index) in leftLists" v-if="key == '咨询'">-->
<!--                <router-link :to="{name:value.route, params :{id:value.id,type:value.type}} "-->
<!--                             class="nav-link text-muted" :class="{'mid':linkshow}">-->
<!--                    &lt;!&ndash;<i class="navbar-icon-shouye"></i>&ndash;&gt;-->
<!--                    <i class="fa fa-graduation-cap mr-2"></i>-->
<!--                    <span v-show="!linkshow">{{key}}</span>-->
<!--                </router-link>-->
<!--            </li>-->
<!--            <li class="nav-item" v-for="(value, key, index) in leftLists"-->
<!--                v-if="key != '报告' && key != '论文' && key != '智讯' && key != '咨询' && key != '数据' && key != '项目' && key !='信用'">-->
<!--                <router-link :to="{name:value.route, params :{id:value.id}} " :class="{'mid':linkshow}"-->
<!--                             class="nav-link text-muted">-->
<!--                    &lt;!&ndash;<i :class="'navbar-icon-' + value.route"></i>&ndash;&gt;-->
<!--                    <i v-if="key == '资讯'" class="fa fa-file-text-o mr-2"></i>-->
<!--                    &lt;!&ndash;<i v-if="key == '智讯'" class="fa fa-at mr-2"></i>&ndash;&gt;-->
<!--                    <i v-if="key == '视讯'" class="fa fa-play-circle mr-2"></i>-->
<!--                    <i v-if="key == '情报'" class="fa fa-building-o mr-2"></i>-->
<!--                    <i v-if="key == '案例'" class="fa fa-book mr-2"></i>-->
<!--                    &lt;!&ndash;<i v-if="key == '咨询'" class="fa fa-graduation-cap mr-2"></i>&ndash;&gt;-->
<!--                    <span v-show="!linkshow">{{key}}</span>-->
<!--                </router-link>-->

<!--            </li>-->

<!--            &lt;!&ndash;<li class="nav-item">-->

<!--                <a href="javascript:;" target="_blank" class="nav-link">-->
<!--                    <i class="fa fa-universal-access mr-2"></i>-->

<!--                        IPR-->
<!--                </a>-->

<!--            </li>&ndash;&gt;-->
<!--            <li class="nav-item" v-for="(value, key, index) in leftLists" v-if="key == '论文'">-->
<!--                <div class="nav-link text-muted" :class="{'mid':linkshow}">-->
<!--                    <div class="btn-group" :class="{'dropright':!linkshow}">-->
<!--                        <i class="fa fa-file-text mr-2" style="line-height: 45px;"></i>-->
<!--                        &lt;!&ndash;<i class="fa fa-address-book mr-2"></i>&ndash;&gt;-->
<!--                        <a href="javascript:;" v-show="!linkshow" style="pointer-events: none;margin-right: 10px" data-toggle="dropdown">{{key}}</a>-->

<!--                        &lt;!&ndash;<span class="dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->

<!--					  	</span>&ndash;&gt;-->
<!--                        <div class="dropdown-menu dropdown-one report_dropdown p-0"-->
<!--                             style="margin-left: 8px;margin-top: -2px;">-->
<!--                            <ul class="list-group">-->
<!--                                <li v-for="(value, key) in value" class="list-group-item w-100"-->
<!--                                    style="line-height: initial;">-->
<!--                                    <router-link :to="{name:value.route, params :{id:value.id}}"-->
<!--                                                 class="nav-link d-inline text-muted">-->
<!--                                        {{key}}-->
<!--                                    </router-link>-->
<!--                                </li>-->
<!--                            </ul>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                </div>-->

<!--            </li>-->
<!--            <li class="nav-item" v-for="(value, key, index) in leftLists" v-if="key == '报告'">-->
<!--                <div class="nav-link text-muted" :class="{'mid':linkshow}">-->
<!--                    <div class="btn-group" :class="{'dropright':!linkshow}">-->
<!--                        <i class="fa fa-bandcamp mr-2" style="line-height: 45px;"></i>-->
<!--                        &lt;!&ndash;<i :class="'navbar-icon-' + value.route"></i>&ndash;&gt;-->
<!--                        <a href="javascript:;" data-toggle="dropdown" v-show="!linkshow" style="pointer-events: none;margin-right: 10px">{{key}}</a>-->

<!--                        &lt;!&ndash;<span class="dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->

<!--                          </span>&ndash;&gt;-->
<!--                        <div class="dropdown-menu dropdown-one report_dropdown p-0"-->
<!--                             style="margin-left: 8px;margin-top: -2px;">-->
<!--                            <ul class="list-group">-->
<!--                                <li v-for="(val, key) in value" v-if="key!='定制报告' && key != '专题报告'"-->
<!--                                    class="list-group-item w-100" style="line-height: initial;">-->
<!--                                    <a href="javascript:;">-->
<!--                                        {{key}}-->
<!--                                    </a>-->
<!--                                    <div class="dropdown-menu dropdown-two report_dropdown p-0"-->
<!--                                         style="margin-top: -2px;">-->
<!--                                        <ul class="list-group">-->
<!--                                            <li v-for="(va, key) in val" class="list-group-item w-100"-->
<!--                                                style="line-height: initial;">-->
<!--                                                <router-link :to="{name:va.route, params :{id:va.id,year:va.year}}"-->
<!--                                                             class="nav-link d-inline text-muted">-->
<!--                                                    {{key}}-->
<!--                                                </router-link>-->
<!--                                            </li>-->
<!--                                        </ul>-->
<!--                                    </div>-->
<!--                                </li>-->
<!--                                <li v-for="(val, key) in value" v-if="key!='投资风险报告' && key != '公共安全报告'"-->
<!--                                    class="list-group-item w-100" style="line-height: initial;">-->
<!--                                    <router-link :to="{name:val.route, params :{id:val.id}}"-->
<!--                                                 class="nav-link d-inline text-muted">-->
<!--                                        {{key}}-->
<!--                                    </router-link>-->
<!--                                </li>-->
<!--                            </ul>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                </div>-->

<!--            </li>-->
<!--            &lt;!&ndash;<li class="nav-item" v-for="(value, key, index) in leftLists" v-if="key == '数据'">&ndash;&gt;-->
<!--                &lt;!&ndash;<router-link :to="{name:value.route}" class="nav-link text-muted" :class="{'mid':linkshow}">&ndash;&gt;-->
<!--                    &lt;!&ndash;<i class="fa fa-bar-chart mr-2"></i>&ndash;&gt;-->
<!--                    &lt;!&ndash;<span v-show="!linkshow">数据</span>&ndash;&gt;-->
<!--                &lt;!&ndash;</router-link>&ndash;&gt;-->
<!--            &lt;!&ndash;</li>&ndash;&gt;-->
<!--            <li class="nav-item" v-for="(value, key, index) in leftLists" v-if="key == '数据'">-->
<!--            <div class="nav-link text-muted" :class="{'mid':linkshow}">-->
<!--                <div class="btn-group" :class="{'dropright':!linkshow}">-->
<!--                    <i class="fa fa-file-text mr-2" style="line-height: 45px;"></i>-->
<!--                    &lt;!&ndash;<i class="fa fa-address-book mr-2"></i>&ndash;&gt;-->
<!--                    <a href="javascript:;" v-show="!linkshow" style="margin-right: 10px" data-toggle="dropdown">{{key}}</a>-->

<!--                    &lt;!&ndash;<span class="dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->

<!--                      </span>&ndash;&gt;-->
<!--                    <div class="dropdown-menu dropdown-one report_dropdown p-0"-->
<!--                         style="margin-left: 8px;margin-top: -2px;">-->
<!--                        <ul class="list-group">-->
<!--                            <li v-for="(value, key) in value" class="list-group-item w-100" style="line-height: initial;">-->
<!--                                <router-link :to="{name:value.route}"-->
<!--                                             class="nav-link d-inline text-muted">-->
<!--                                    {{key}}-->
<!--                                </router-link>-->
<!--                            </li>-->
<!--                        </ul>-->
<!--                    </div>-->
<!--                </div>-->

<!--            </div>-->

<!--        </li>-->
<!--            &lt;!&ndash;<li class="nav-item">&ndash;&gt;-->
<!--                &lt;!&ndash;&lt;!&ndash;<i class="navbar-icon-xinyong"></i>&ndash;&gt;&ndash;&gt;-->
<!--                &lt;!&ndash;&lt;!&ndash;<a href="http://db.silkroad.news.cn/credit.shtml" target="_blank" class="nav-link">&ndash;&gt;-->
<!--                    &lt;!&ndash;<i class="fa fa-credit-card-alt mr-2"></i>&ndash;&gt;-->
<!--                    &lt;!&ndash;信用&ndash;&gt;-->
<!--                &lt;!&ndash;</a>&ndash;&gt;&ndash;&gt;-->
<!--                &lt;!&ndash;<router-link to="/credit" class="nav-link text-muted" :class="{'mid':linkshow}">&ndash;&gt;-->

<!--                    &lt;!&ndash;<i class="fa fa-credit-card-alt mr-2"></i>&ndash;&gt;-->
<!--                    &lt;!&ndash;<span v-show="!linkshow">信用</span>&ndash;&gt;-->
<!--                &lt;!&ndash;</router-link>&ndash;&gt;-->
<!--            &lt;!&ndash;</li>&ndash;&gt;-->
<!--            <li class="nav-item" v-for="(value, key, index) in leftLists" v-if="key == '信用'">-->
<!--                <router-link :to="{name:value.route}" class="nav-link text-muted" :class="{'mid':linkshow}">-->

<!--                    <i class="fa fa-credit-card-alt mr-2"></i>-->
<!--                    <span v-show="!linkshow">信用</span>-->
<!--                </router-link>-->
<!--            </li>-->
<!--            <li class="nav-item" v-for="(value, key, index) in leftLists" v-if="key == '项目'">-->
<!--                <router-link :to="{name:value.route}" class="nav-link text-muted" :class="{'mid':linkshow}">-->

<!--                    <i class="fa fa-window-restore mr-2"></i>-->
<!--                    <span v-show="!linkshow">项目</span>-->
<!--                </router-link>-->
<!--            </li>-->
<!--            <li class="nav-item">-->
<!--                <router-link to="/garden" class="nav-link text-muted" :class="{'mid':linkshow}">-->
<!--                    &lt;!&ndash;<i class="navbar-icon-yuanqu"></i>&ndash;&gt;-->
<!--                    <i class="fa fa-institution mr-2"></i>-->
<!--                    <span v-show="!linkshow">园区</span>-->
<!--                </router-link>-->
<!--            </li>-->
<!--            &lt;!&ndash;<li class="nav-item">&ndash;&gt;-->
<!--                &lt;!&ndash;<router-link to="/intellectual" class="nav-link text-muted" :class="{'mid':linkshow}">&ndash;&gt;-->
<!--                    &lt;!&ndash;&lt;!&ndash;<i class="navbar-icon-yuanqu"></i>&ndash;&gt;&ndash;&gt;-->
<!--                    &lt;!&ndash;<i class="fa fa-creative-commons mr-2"></i>&ndash;&gt;-->
<!--                    &lt;!&ndash;<span v-show="!linkshow">知识产权</span>&ndash;&gt;-->
<!--                &lt;!&ndash;</router-link>&ndash;&gt;-->
<!--            &lt;!&ndash;</li>&ndash;&gt;-->
        </ul>
    </div>
</template>
<script>
    export default ({
        name: 'homeList',
        data: function () {
            return {
                leftLists: [],
                linkshow: false,
                screenWidth: document.body.clientWidth,
                timer: null,
                h1:"",
                h2:"",
                h3:"",// 承受3个含有子集的nav，新增就继续增加h4....
                h4:"",// 承受3个含有子集的nav，新增就继续增加h4....
            }

        },
        updated:function(){
            var that=this;
            that.$nextTick(function() {
                setTimeout(function () {
                    $('.mynavStyle').css({"height":window.screen.height-150});
                },1500)
                $('.mynavStyle .btn-group').eq(0).parents('li')&&(that.h1 = $('.mynavStyle .btn-group').eq(0).parents('li').index() * 45 + 22.5)&&$('.mynavStyle .btn-group').eq(0).css({'top':(that.h1-5)});
                $('.mynavStyle .btn-group').eq(1).parents('li')&&(that.h2 = $('.mynavStyle .btn-group').eq(1).parents('li').index() * 45 + 22.5)&&$('.mynavStyle .btn-group').eq(1).css({'top':(that.h2-5)});
                $('.mynavStyle .btn-group').eq(2).parents('li')&&(that.h3 = $('.mynavStyle .btn-group').eq(2).parents('li').index() * 45 + 22.5)&&$('.mynavStyle .btn-group').eq(2).css({'top':(that.h3-5)});
                $('.mynavStyle .btn-group').eq(3).parents('li')&&(that.h4 = $('.mynavStyle .btn-group').eq(3).parents('li').index() * 45 + 22.5)&&$('.mynavStyle .btn-group').eq(3).css({'top':(that.h4-5)});
            })
        },
        created: function () {
            var self = this;
            var window_width = $(window).width();//获取浏览器窗口宽度
            this.$axios.post('/api/pc/getmenu').then(function (data) {
                var leftLists = data.data.data;
                self.leftLists = leftLists;
            }, function (response) {
                console.info(response);
                if (response) {
                    console.log("失败");
                }
            })
            if (this.IsPC()) {
                if (window_width < 1010) {
                    self.linkshow = true
                } else {
                    self.linkshow = false
                }

                self.$store.state.footerShow = false
            }
        },
        computed: {
            isFollow() {
                return this.$store.state.screenWidth;
            },
            isNavHeight() {
                return this.$store.state.screenHeight-150;
            },
            // isNavScroll() {
            //     return this.$store.state.navScroll;
            // }
        },
        watch: {
            isFollow(val) {
                if (!this.timer) {
                    this.screenWidth = val;
                    this.timer = true;
                    let that = this;
                    setTimeout(function () {
                        // that.screenWidth = that.$store.state.canvasWidth
                        if (val < 1010) {
                            that.linkshow = true
                        } else {
                            that.linkshow = false
                        }

                        // if(val<544){
                        //     that.$store.state.footerShow=true
                        // }else{
                        //     that.$store.state.footerShow=false
                        // }
                        that.timer = false
                    }, 300)
                }

            },
            isNavHeight(val){
                $('.mynavStyle').css({"height":val});
            },

            // isNavScroll(val){
            //     debugger
            //     $.each($('.mynavStyle .btn-group'),function(i,elm){
            //         var h=$(elm).parents('li').offset().top;
            //         $(elm).parents('li').css({'top':h+val})
            //     })
            // }
        },
        mounted: function () {


            if (this.IsPC()) {
                /*window.onresize = () => {
                    return (() => {
                        that.screenWidth = document.body.clientWidth;
                        that.$store.state.screenWidth=document.body.clientWidth;
                    })()
                }*/
                const that = this;
                /*window.onresize = function() {
                        console.log(document.body.clientWidth)
                        that.screenWidth = document.body.clientWidth;
                        that.$store.state.screenWidth = document.body.clientWidth;
                }*/


                if (window.attachEvent) {
                    window.attachEvent('resize', function () {
                        that.screenWidth = document.body.clientWidth;
                        that.$store.state.screenWidth = document.body.clientWidth;
                        that.$store.state.screenHeight = document.body.clientHeight;
                    })
                } else {
                    window.addEventListener('resize', function () {
                        that.screenWidth = document.body.clientWidth;
                        that.$store.state.screenWidth = document.body.clientWidth;
                        that.$store.state.screenHeight = document.body.clientHeight;
                    })
                }
            } else {
                var moveStart = 0;
                var isDragging = false
                var p=0,t=0;
                var that=this;
                window.addEventListener('scroll', function (e) {
                    p = $(this).scrollTop();
                    if(t<=p){//下滚
                        that.$store.state.footerShow = false
                    }

                    else{//上滚
                        that.$store.state.footerShow = true
                    }
                    setTimeout(function(){t = p;},0);
                })
               // $('#myapp').on("touchstart", function (e) {
               //      e = e || window.event;
               //      // e.preventDefault();
               //     isDragging = false;
               //      moveStart = e.originalEvent.changedTouches[0].pageY;
               //  });
               //  $('#myapp').on("touchmove", function (e) {
               //      // e.preventDefault();
               //      e = e || window.event;
               //      isDragging = true;
               //      var moveX = e.originalEvent.changedTouches[0].pageX;
               //
               //  });
               //  $('#myapp').on("touchend", function (e) {
               //      if(isDragging) return false;
               //      // e.preventDefault();
               //      e = e || window.event;
               //      var moveEnd_Y = e.originalEvent.changedTouches[0].pageY - moveStart;
               //      var direction = moveEnd_Y > 0 ? 'down' : 'up';
               //      if (that.$store.state.screenWidth < 544) {
               //          if (direction == 'up') {
               //                  that.$store.state.footerShow = false
               //          } else {
               //              that.$store.state.footerShow = true
               //          }
               //      }
               //  })
            }
        },
        methods: {
            getWidth: function () {
                console.log(this.$refs.myapp.clientWidth)
            },
            MyScorll:function (obj) {
                var _this=this;
                // this.$store.state.navScroll=this.$refs.box.scrollTop;
                // $.each($('.mynavStyle .btn-group'),function(i,elm){
                //     console.log("h"+h,"top"+_this.$refs.box.scrollTop);
                //     $(elm).css({'top':_this.`h+i`,_this.$refs.box.scrollTop})
                // })

                $('.mynavStyle .btn-group').eq(0).parents('li')&&$('.mynavStyle .btn-group').eq(0).css({'top':(_this.h1-(_this.$refs.box.scrollTop)-5)})
                $('.mynavStyle .btn-group').eq(1).parents('li')&&$('.mynavStyle .btn-group').eq(1).css({'top':(_this.h2-(_this.$refs.box.scrollTop)-5)})
                $('.mynavStyle .btn-group').eq(2).parents('li')&&$('.mynavStyle .btn-group').eq(2).css({'top':(_this.h3-(_this.$refs.box.scrollTop)-5)})
                $('.mynavStyle .btn-group').eq(3).parents('li')&&$('.mynavStyle .btn-group').eq(3).css({'top':(_this.h4-(_this.$refs.box.scrollTop)-5)})
            }
        }

    })
</script>
<style scoped>
    .nav-item a{
        font-size: 12px;
    }
    .nav-pills .nav-link.mid {
        height: 100%;
        font-size: 18px;
        justify-content: center;
        padding-left: 0;
    }
    .mynavStyle{
        overflow-y: auto;
        flex-wrap: initial;
    }
    .mynavStyle .btn-group{
        position:absolute;
    }
    .mynavStyle::-webkit-scrollbar{
        width: .1px;     /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
    }
    .nav-pills .nav-link.mid i {
        margin-right: 0 !important;
    }

    .nav-pills .nav-link.mid .dropdown-two {
        left: 100%;
        top: 0;
    }

    .nav-pills .nav-link.mid .dropdown-one {
        top: 0;
        left: 100%;
    }
    .left_content ul li>div{
        height: 45px;
    }
    .nav-pills .nav-link:hover {
        cursor: pointer;
    }
    .left_content ul li{
        /*position:relative;*/
    }
    .nav-pills .nav-link{
        font-size: 12px;
        padding-left: 10%;
    }
</style>
